<template>
  <div>
    <TeCourseDesignPortfolioCover
      :begins-at="beginsAt"
      :closes-at="closesAt"
    />

    <TeCommonPagenav class="hidden md:block">
      <template #courseicon>
        <FontAwesomeIcon
          :icon="faBook"
          class="fa-fw mr-2 size-5"
        />
      </template>
      <template #coursename>
        デザイン実践ポートフォリオ<span class="hidden md:inline">コース</span>
      </template>
    </TeCommonPagenav>

    <!-- 無料相談割引コード -->
    <TeCommonBannerTimeLimitCpnCode
      v-if="BannerNameForShowing === 'campaign'"
      :entry-campaign="entryCampaign"
    />

    <TeCommonBannerSettlement
      v-if="BannerNameForShowing === 'settlement'"
      :entry-settlement-time-limit="entrySettlementTimeLimit"
      :entry-payment-url="entryPaymentUrl"
    />
    <TeCommonBannerTimelimit
      v-if="BannerNameForShowing === 'discount'"
      :entry-discount-time-limit="entryDiscountTimeLimit"
    />
    <TeCommonBannerCampaign
      :course-name-path="courseNamePath"
      :current-promotion="currentPromotion"
    />

    <TeCourseAbout>
      <template #title>
        デザイン実践ポートフォリオコースについて
      </template>
      <template #discription>
        <p class="co-display-10 mb-3 inline text-co-gray-500 md:block">
          1人では続かない方のためのパーソナルメンターがつく学習プログラム。
        </p>
        <p class="co-display-10 mb-3 inline text-co-gray-500 md:block">
          週2回マンツーマンでのメンタリング、毎日のチャット・レビューサポートで
        </p>
        <p class="co-display-10 mb-3 inline text-co-gray-500 md:block">
          実践的なデザインスキルを身につけることができる学習プログラム。
        </p>
        <p class="co-display-10 mb-0 inline text-co-gray-500 md:block">
          PhotoshopやXDを使いこなして実務で通用するスキルを身につけることがゴールです。
        </p>
      </template>
    </TeCourseAbout>

    <TeCourseDesignPortfolioTarget />

    <TeCommonDemographics />

    <TeCourseDesignPortfolioOutput />

    <TeCourseDesignPortfolioCurriculum />

    <TeCommonBannerAdobe />

    <!-- 251202導線削除 -->
    <!-- <TeCommonBannerFreeTrial id="cta-first" /> -->

    <!-- 挫折させないパーソナルメンターサポート -->
    <section
      id="mentor-support"
      class="co-bg-striped"
    >
      <div class="co-container-lg px-4 pt-20">
        <h2 class="co-heading-2-caption">
          挫折させない<span class="block md:inline">パーソナルメンターサポート</span>
        </h2>
        <h3 class="co-display-12 mb-[3.25rem] text-left leading-base text-co-gray-600 md:text-center">
          学習時の「わからない」「続かない」を解消し、挫折をなくします。
          <br class="hidden md:block">
          実務で培った技術とノウハウで受講生一人ひとりをサポートします。
        </h3>
        <div class="flex flex-col justify-center gap-x-8 sm:px-36 lg:flex-row lg:px-0">
          <TeCommonMentorSupportMentoring />

          <TeCommonMentorSupportChatSupport />

          <TeCommonMentorSupportIssueReview />
        </div>
      </div>
      <TeCommonMentorSupportAboutFlow>
        <template #flowOriginalText>
          実務レベルのデザインスキル習得
        </template>
        <template #originalTitle>
          実務レベルのデザインスキル習得までサポート
        </template>
        <template #originalLead>
          受講目的や習得スキルに合わせて、複数パターンのデザイン知識・制作技術を学び、実務レベルのデザインスキル習得まで徹底サポートします。
        </template>
      </TeCommonMentorSupportAboutFlow>

      <TeCommonMentorSupportMentor :one-column="true">
        <template #mentor>
          Webデザイナー
        </template>

        <template #mentorImage1>
          <img
            class="size-full object-cover"
            src="~/assets/images/Te/TeCommon/MentorSupport/Mentor/mentor-masuda.jpg"
            alt="Naoko Masuda"
            width="213"
            height="213"
            loading="lazy"
          >
        </template>
        <template #mentorName1>
          Naoko
          <br>
          Masuda
        </template>
        <template #mentorProfile1>
          HTMLという言葉も知らなかった状態から勉強をし始めて2年後にフリーランスとして独立。現在ではWordPressを得意とするWebデザイナー・エンジニアとして活躍しています。
        </template>
        <template #mentorMessage1>
          働き方の見直しや昨今のご時世でWebデザイナーやエンジニアを希望する人は急激に増えています。じゃあ今から勉強しても遅い？全然そんなことありません。スキル獲得のその先にある「なりたい自分」になるための第一歩のお手伝いをいたします。
        </template>
      </TeCommonMentorSupportMentor>

      <TeCommonMentorSupportReason>
        <template #mentorType>
          Webデザイナー
        </template>
      </TeCommonMentorSupportReason>
    </section>

    <TeCommonLearningCycle>
      <template #image>
        <img
          class="mx-auto w-3/4 sm:w-1/2 md:w-full"
          src="~/assets/images/Te/TeCommon/LearningCycle/cycle-design.svg"
          alt="学習サイクル デザイン"
          loading="lazy"
        >
      </template>
      <template #catchTwo>
        実践に近い形で
        <span class="text-co-primary-500">デザインする</span>
      </template>
      <template #textTwo>
        知識を「学ぶ」だけでなく、実際に「使える」ようになるために、実践に近い形でデザインします。
        チュートリアル形式のカリキュラムを進めることでデザインスキルを身につけます。
      </template>
      <template #textThree>
        自習していてわからないところを1人で悩まずに、すぐにメンターに聞いて解決することが重要です。
        オンラインで常駐している現役Webデザイナーのメンターが、あなたの質問に素早く回答します。
      </template>
    </TeCommonLearningCycle>

    <TeCommonSliderVoice />

    <!-- 251202導線削除 -->
    <!-- <TeCommonBannerFreeTrial id="cta-second" /> -->

    <TeCommonCampaign
      :course-name-path="courseNamePath"
      :current-promotion="currentPromotion"
    />

    <section
      id="price"
      class="co-bg-striped"
    >
      <!-- 無料相談割引コード -->
      <TeCommonBannerTimeLimitCpnCode
        v-if="BannerNameForShowing === 'campaign'"
        :entry-campaign="entryCampaign"
      />

      <div class="co-container-lg px-4 py-20 xl:px-0">
        <h2 class="co-display-7 mb-[3.25rem] text-center">
          料金
        </h2>

        <TeCommonPriceTimeLimit
          v-if="BannerNameForShowing === 'discount'"
          :entry-discount-time-limit="entryDiscountTimeLimit"
        />

        <TeCoursePriceTable3Columns
          :course="course"
          :latest-cohort="latestCohort"
          :current-promotion="currentPromotion"
          :mentoring="true"
          :chat-support="true"
        >
          <template #chatSupportTime>
            24時間以内に回答
          </template>
        </TeCoursePriceTable3Columns>

        <TeCoursePriceInstallments
          :course="course"
          :installments-social="true"
        />

        <!-- 参加条件 -->
        <TeCommonPriceParticipationconditions>
          <template #conditionList>
            <li class="mb-2">
              Photoshopの使用方法について理解している
            </li>
            <li class="mb-2">
              必要なメンタリング回数をこなすことが出来る
            </li>
            <li class="mb-2">
              期間内に必要な学習時間を確保出来る
            </li>
            <li class="mb-2">
              MacかWindowsのPCを持っている
            </li>
            <li class="mb-2">
              PCスペック：Photoshop・AdobeXDの最小技術仕様を満たしている
              <div class="ml-5">
                （詳細な内容は<a
                  href="https://helpx.adobe.com/jp/photoshop/system-requirements.html"
                  target="_blank"
                >こちら</a>
                ）
              </div>
            </li>
            <li class="mb-2">
              Google Chrome を利用できる
            </li>
            <li class="mb-2">
              PCの基本的な操作が問題なくできる
            </li>
            <li>ビデオチャットが可能な通信環境</li>
          </template>
        </TeCommonPriceParticipationconditions>

        <div class="flex flex-col items-center lg:flex-row lg:items-start lg:gap-x-8">
          <!-- 注意事項 -->
          <TeCommonPricePrecautions>
            <template #preCautionsList>
              <li class="mb-2">
                支払い方法はクレジットカード払い（分割可能）、コンビニ決済、銀行振込、Amazon Pay、PayPayからお選びいただけます。
              </li>
              <li class="mb-2">
                クレジットカード払いは、Visa、Master、JCB、AMEX、Dinersに対応しています。
              </li>
              <li class="mb-2">
                カード分割払いご利用回数（3/5/6/10/12/15/18/20/24）
              </li>
              <li class="mb-2">
                Dinersは分割の支払いが利用できません。
              </li>
              <li class="mb-2">
                コンビニ決済は30万円を超える支払いにはご利用いただけません。
              </li>
              <li class="mb-2">
                50万円を超えるPayPay決済をご利用の際は、本人確認の認証が必要となります。
              </li>
              <li class="mb-2">
                請求書払いをご希望の場合はお申込後、専用のフォームからご申請ください。
              </li>
              <li class="mb-2">
                決済後、専用のフォームから領収書の発行が可能です。
              </li>
              <li class="mb-2">
                参加にはウェブカメラ、マイクが必要となります。
              </li>
              <li>12/28から1/3はメンターサポート休止期間です。受講期間がサポート休止期間にかかる場合、受講が最大7日間延長されます。</li>
            </template>
          </TeCommonPricePrecautions>
          <!-- キャンセルポリシー -->
          <TeCommonPriceCancelPolicy />
        </div>
      </div>
    </section>

    <TeCommonTomowari
      bg="#e09a44"
      title-bg="#cf8122"
    />

    <!-- 251202導線削除 -->
    <!-- <TeCommonBannerFreeTrial id="cta-third" /> -->

    <TeCommonCareerSupport />

    <TeCommonComparisonSchool :original-assignment="true">
      <template #teacher>
        デザイナー
      </template>
      <template #mentor>
        現役デザイナー
      </template>
    </TeCommonComparisonSchool>

    <TeCourseMessage>
      <template #chatch02>
        デザイン
      </template>
    </TeCourseMessage>

    <TeCourseDesignPortfolioFlow />

    <!-- 251202導線削除 -->
    <!-- <TeCourseDesignPortfolioFaQ /> -->

    <!-- 無料相談割引コード -->
    <TeCommonBannerTimeLimitCpnCode
      v-if="BannerNameForShowing === 'campaign'"
      :entry-campaign="entryCampaign"
    />

    <TeCourseApply
      :course="course"
      :cohorts="cohorts"
      :latest-cohort="latestCohort"
      :sakiwari-cohorts="sakiwariCohorts"
      :current-promotion="currentPromotion"
      :course-name-path="courseNamePath"
      :entry-discount-time-limit="entryDiscountTimeLimit"
      :entry-campaign="entryCampaign"
    />

    <!-- 下部固定ボタン -->
    <!-- 251202導線削除 -->
    <!-- <TeCommonButtonFixedBottom /> -->
  </div>
</template>

<script lang="ts">
import { metaTags } from '~/utility/constants/metaTags'
import { IndexServices } from '~/services/indexService'
import { scriptTag } from '~/utility/scriptTag'
import {
  getCohorts,
  getCurrentPromotion,
  getCourse,
  getFirstOpenedWholeCohort,
} from '~/utility/fetchAPI'
import { getAdItem } from '~/utility/utility'

import TeCourseDesignPortfolioCover from '~/components/Te/TeCourse/DesignPortfolio/TeCourseDesignPortfolioCover.vue'
import TeCommonPagenav from '~/components/Te/TeCommon/Pagenav/TeCommonPagenav.vue'
import TeCommonBannerTimeLimitCpnCode from '~/components/Te/TeCommon/Banner/TeCommonBannerTimeLimitCpnCode/TeCommonBannerTimeLimitCpnCode.vue'
import TeCommonBannerSettlement from '~/components/Te/TeCommon/Banner/TeCommonBannerSettlement/TeCommonBannerSettlement.vue'
import TeCommonBannerTimelimit from '~/components/Te/TeCommon/Banner/TeCommonBannerTimelimit/TeCommonBannerTimelimit.vue'
import TeCommonBannerCampaign from '~/components/Te/TeCommon/Banner/TeCommonBannerCampaign/TeCommonBannerCampaign.vue'
import TeCourseAbout from '~/components/Te/TeCourse/TeCourseAbout.vue'
import TeCourseDesignPortfolioTarget from '~/components/Te/TeCourse/DesignPortfolio/TeCourseDesignPortfolioTarget.vue'
import TeCommonDemographics from '~/components/Te/TeCommon/TeCommonDemographics/TeCommonDemographics.vue'
import TeCourseDesignPortfolioOutput from '~/components/Te/TeCourse/DesignPortfolio/TeCourseDesignPortfolioOutput.vue'
import TeCourseDesignPortfolioCurriculum from '~/components/Te/TeCourse/DesignPortfolio/TeCourseDesignPortfolioCurriculum.vue'
import TeCommonBannerAdobe from '~/components/Te/TeCommon/Banner/TeCommonBannerAdobe/TeCommonBannerAdobe.vue'
import TeCommonBannerFreeTrial from '~/components/Te/TeCommon/Banner/TeCommonBannerFreeTrial/TeCommonBannerFreeTrial.vue'
import TeCommonMentorSupportMentoring from '~/components/Te/TeCommon/MentorSupport/TeCommonMentorSupportMentoring/TeCommonMentorSupportMentoring.vue'
import TeCommonMentorSupportChatSupport from '~/components/Te/TeCommon/MentorSupport/TeCommonMentorSupportChatSupport/TeCommonMentorSupportChatSupport.vue'
import TeCommonMentorSupportIssueReview from '~/components/Te/TeCommon/MentorSupport/TeCommonMentorSupportIssueReview/TeCommonMentorSupportIssueReview.vue'
import TeCommonMentorSupportAboutFlow from '~/components/Te/TeCommon/MentorSupport/TeCommonMentorSupportAboutFlow/TeCommonMentorSupportAboutFlow.vue'
import TeCommonMentorSupportMentor from '~/components/Te/TeCommon/MentorSupportMentor/TeCommonMentorSupportMentor.vue'
import TeCommonMentorSupportReason from '~/components/Te/TeCommon/MentorSupport/TeCommonMentorSupportReason/TeCommonMentorSupportReason.vue'
import TeCommonLearningCycle from '~/components/Te/TeCommon/TeCommonLearningCycle/TeCommonLearningCycle.vue'
import TeCommonSliderVoice from '~/components/Te/TeCommon/Slider/TeCommonSliderVoice/TeCommonSliderVoice.vue'
import TeCommonCampaign from '~/components/Te/TeCommon/TeCommonCampaign/TeCommonCampaign.vue'
import TeCommonPriceTimeLimit from '~/components/Te/TeCommon/Price/TeCommonPriceTimeLimit/TeCommonPriceTimeLimit.vue'
import TeCoursePriceTable3Columns from '~/components/Te/TeCourse/TeCoursePriceTable3Columns.vue'
import TeCoursePriceInstallments from '~/components/Te/TeCourse/TeCoursePriceInstallments.vue'
import TeCommonPriceParticipationconditions from '~/components/Te/TeCommon/Price/TeCommonPriceParticipationconditions/TeCommonPriceParticipationconditions.vue'
import TeCommonPricePrecautions from '~/components/Te/TeCommon/Price/TeCommonPricePrecautions/TeCommonPricePrecautions.vue'
import TeCommonPriceCancelPolicy from '~/components/Te/TeCommon/Price/TeCommonPriceCancelPolicy/TeCommonPriceCancelPolicy.vue'
import TeCommonTomowari from '~/components/Te/TeCommon/Tomowari/TeCommonTomowari.vue'
import TeCommonCareerSupport from '~/components/Te/TeCommon/TeCommonCareerSupport/TeCommonCareerSupport.vue'
import TeCommonComparisonSchool from '~/components/Te/TeCommon/Comparison/TeCommonComparisonSchool/TeCommonComparisonSchool.vue'
import TeCourseMessage from '~/components/Te/TeCourse/TeCourseMessage.vue'
import TeCourseDesignPortfolioFlow from '~/components/Te/TeCourse/DesignPortfolio/TeCourseDesignPortfolioFlow.vue'
import TeCourseDesignPortfolioFaQ from '~/components/Te/TeCourse/DesignPortfolio/TeCourseDesignPortfolioFaQ.vue'
import TeCourseApply from '~/components/Te/TeCourse/TeCourseApply.vue'
import TeCommonButtonFixedBottom from '~/components/Te/TeCommon/Button/TeCommonButtonFixedBottom/TeCommonButtonFixedBottom.vue'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faBook } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

const options = {
  async setup() {
    const route = useRoute()
    const courseNamePath = route.path.split('/')[2]
    const course = ref<Object | null>(null)

    return {
      route,
      course,
      courseNamePath,
      faBook,
    }
  },
  oldHead() {
    const scriptTags = scriptTag({
      facebookPixelCode: true,
      criteoScript: true,
      criteoItem: {
        deviceSize: useNuxtApp().$deviceSize,
        item: this.course?.id,
      },
      remarketingTag: {
        ad_item_id: this.course?.id,
        ad_item_price: this.course ? getAdItem(this.course) : null,
      },
    })
    return {
      title: 'Webデザインのスキルアップに/専属メンター付 | テックアカデミー',
      meta: [
        ...metaTags({
          description:
            '【テックアカデミー(TechAcademy)】選抜された現役デザイナーから学べるWebデザインの講座。受講者数No.1のオンラインプログラミングスクール。専属のパーソナルメンターが制作業務で通用するデザインスキルが身につくまでマンツーマンでサポート。',
          twitterTitle: 'デザイン実践ポートフォリオコース',
          twitterDescription:
            'デザインの実践スキルを選抜された現役デザイナーから自宅で学べる。パーソナルメンターがマンツーマンで学習サポート。',
          twitterImage: '/_nuxt/ogp/te/tecourse/og-image-design-portfolio.jpg',
          ogTitle: 'デザイン実践ポートフォリオコース',
          ogDescription:
            'デザインの実践スキルを選抜された現役デザイナーから自宅で学べる。パーソナルメンターがマンツーマンで学習サポート。',
          ogUrl: '/course/design-portfolio',
          ogImage: '/_nuxt/ogp/te/tecourse/og-image-design-portfolio.jpg',
        }),
      ],
      script: scriptTags.script,
      noscript: scriptTags.noscript,
    }
  },
  data() {
    return {
      cohorts: [],
      latestCohort: null,
      sakiwariCohorts: [],
      currentPromotion: null,
      screenName: '',
      entryDiscountTimeLimit: null,
      entrySettlementTimeLimit: null,
      entryPaymentUrl: null,
      entryCampaign: null,
    }
  },
  async mounted() {
    const {
      data: {
        entryDiscountTimeLimit,
        entrySettlementTimeLimit,
        entryPaymentUrl,
        entryCampaign,
      },
    } = await new IndexServices(this.$api).getTopTimeLimits()
    this.entryDiscountTimeLimit = entryDiscountTimeLimit
    this.entrySettlementTimeLimit = entrySettlementTimeLimit
    this.entryPaymentUrl = entryPaymentUrl
    this.entryCampaign = entryCampaign

    const queryConfig = {
      course_screen_name: this.courseNamePath,
      normal_opened: true,
    }
    getCohorts(this.$api, queryConfig).then((response) => {
      this.cohorts = response.data
      this.latestCohort = response.data[0]
    })
    getCohorts(this.$api, {
      course_screen_name: this.courseNamePath,
      sakiwari: true,
    }).then((response) => {
      this.sakiwariCohorts = response.data
    })
    getCurrentPromotion(this.$api).then((response) => {
      this.currentPromotion = response.data
    })
    getFirstOpenedWholeCohort(this.$api).then((response) => {
      this.firstOpenedWholeCohort = response.data
    })
    this.course = (
      await getCourse(this.$api, this.courseNamePath, { include_pack: true })
    )?.data
  },
  computed: {
    BannerNameForShowing() {
      if (this.entrySettlementTimeLimit) {
        return 'settlement'
      } else if (this.entryCampaign) {
        return 'campaign'
      } else if (this.entryDiscountTimeLimit) {
        return 'discount'
      } else {
        return null
      }
    },
    beginsAt() {
      return this.latestCohort
        ? new Date(this.latestCohort.attributes.begins_at)
        : null
    },
    closesAt() {
      return this.latestCohort
        ? new Date(this.latestCohort.attributes.closes_at)
        : null
    },
  },
  methods: {},
  components: {
    TeCourseDesignPortfolioCover,
    TeCommonPagenav,
    TeCommonBannerTimeLimitCpnCode,
    TeCommonBannerSettlement,
    TeCommonBannerTimelimit,
    TeCommonBannerCampaign,
    TeCourseAbout,
    TeCourseDesignPortfolioTarget,
    TeCommonDemographics,
    TeCourseDesignPortfolioOutput,
    TeCourseDesignPortfolioCurriculum,
    TeCommonBannerAdobe,
    TeCommonBannerFreeTrial,
    TeCommonMentorSupportMentoring,
    TeCommonMentorSupportChatSupport,
    TeCommonMentorSupportIssueReview,
    TeCommonMentorSupportAboutFlow,
    TeCommonMentorSupportMentor,
    TeCommonMentorSupportReason,
    TeCommonLearningCycle,
    TeCommonSliderVoice,
    TeCommonCampaign,
    TeCommonPriceTimeLimit,
    TeCoursePriceTable3Columns,
    TeCoursePriceInstallments,
    TeCommonPriceParticipationconditions,
    TeCommonPricePrecautions,
    TeCommonPriceCancelPolicy,
    TeCommonTomowari,
    TeCommonCareerSupport,
    TeCommonComparisonSchool,
    TeCourseMessage,
    TeCourseDesignPortfolioFlow,
    TeCourseDesignPortfolioFaQ,
    TeCourseApply,
    TeCommonButtonFixedBottom,
    FontAwesomeIcon,
  },
}

export default defineNuxtComponent(options)
</script>
